import { TextField, Switch, FormControlLabel, Box, Typography } from '@mui/material';

interface SettingInputProps {
  settingKey: string;
  value: string;
  valueType: 'string' | 'number' | 'boolean' | 'json';
  onChange: (value: string) => void;
  disabled?: boolean;
}

/**
 * SettingInput - Smart input that renders based on value_type
 * Handles string, number, boolean, and JSON value types
 */
export const SettingInput = ({
  settingKey,
  value,
  valueType,
  onChange,
  disabled = false,
}: SettingInputProps) => {
  const handleBooleanChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked ? 'true' : 'false');
  };

  const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  switch (valueType) {
    case 'boolean':
      return (
        <FormControlLabel
          control={
            <Switch
              checked={value === 'true'}
              onChange={handleBooleanChange}
              disabled={disabled}
            />
          }
          label={value === 'true' ? 'Enabled' : 'Disabled'}
        />
      );

    case 'number':
      return (
        <TextField
          type="number"
          value={value}
          onChange={handleTextChange}
          disabled={disabled}
          size="small"
          fullWidth
          InputProps={{
            inputProps: {
              step: 'any',
            },
          }}
        />
      );

    case 'json':
      return (
        <TextField
          value={value}
          onChange={handleTextChange}
          disabled={disabled}
          multiline
          rows={4}
          fullWidth
          size="small"
          InputProps={{
            sx: {
              fontFamily: 'monospace',
              fontSize: '0.875rem',
            },
          }}
          placeholder='{"key": "value"}'
        />
      );

    case 'string':
    default:
      return (
        <TextField
          value={value}
          onChange={handleTextChange}
          disabled={disabled}
          size="small"
          fullWidth
        />
      );
  }
};
